module.exports = __webpack_public_path__ + "img/7.ca34034f.png";